import React from 'react';

import { Lightbox, PageTitle, SidebarHeading } from '../../../components';
import { preventions } from '../../../constants';
import { renderIcon } from '../../../utils';

import { FaCogs, FaFireExtinguisher, FaUsers } from 'react-icons/fa';

import { Link, useLocation } from 'react-router-dom';



const PreventionSingle = () => {

  const location = useLocation();
  const prev = location.state;

  const installations = prev.installations;
  const considerations = prev.considerations;
  const impacts = prev.impacts;

  return (
    <>
      {/* Page Title */}
      <PageTitle title={prev.title} page={"Prevention Single"} />

      <section className='prev-single page-single'>

        <div className='prev-info page-info'>

          {/* Prevention Image */}
          <div className='image'>
            <img src={prev.image} alt={prev.title} />
          </div>

          <div className='content'>

            {/* Prevention heading */}
            <h3 className='main-heading'>{prev.title}</h3>

            {/* Prevention Content */}
            {prev.overviews.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

          </div>

          {/* Prevention Image gallery */}
          <Lightbox images={prev.gallery} />

          {/* Installation Steps */}
          <div className='installation sub-section'>

            <h3 className='sub-heading'>Installation Steps</h3>

            <p>Follow these step-by-step instructions to ensure a smooth and successful installation of {prev.title}:</p>

            {/* List of Installation Step */}
            <ul>
              {installations.map((step, index) => {
                return <li key={index}><FaCogs className='icon' />{step}</li>
              })}
            </ul>

          </div>

          {/* Key Considerations */}
          <div className='consideration sub-section'>

            <h3 className='sub-heading'>Key Considerations</h3>

            <p>Before implementing our {prev.title} service, consider the following important factors to ensure optimal effectiveness and safety:</p>

            {/* List of Considerations */}
            <ul>
              {considerations.map((item, index) => {
                return <li key={index}><FaFireExtinguisher className='icon' />{item}</li>
              })}
            </ul>

          </div>

          {/* Community Impacts */}
          <div className='impacts sub-section'>

            <h3 className='sub-heading'>Community Impacts</h3>

            <p>Discover how our {prev.title} service creates meaningful and lasting impacts within the community:</p>

            {/* List of Impacts */}
            <ul>
              {impacts.map((impact, index) => {
                return <li key={index}><FaUsers className='icon' />{impact}</li>
              })}
            </ul>

          </div>

        </div>

        <div className='sidebar prev-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'Fire Preventions'} />

            <div className='box-container'>
              {preventions.map(prev => {
                return  (
                /* Link to the individual prevention page */
                <Link
                  to={{
                    pathname: '/Preventions/' + prev.title,
                  }}
                  location = {{prev}}
                  state= {prev}
                  key={prev.id}
                  className='item'><span><div className='icon'>{renderIcon(prev.title)}</div>{prev.title}</span> {/* Prevention Title */}
                </Link> )
              })}
            </div>

          </div>

        </div>

      </section>
    </>
  );
}

export default PreventionSingle;